import React, { createContext, useContext, useMemo } from "react";
import rainbowDeployment from "./deployments/rainbow";
import defaultDeployment from "./deployments/default";
import { useCompanion } from "./CompanionContext";

/**
 * DeploymentContent — narrative bundle for the active deployment.
 *
 * Distinct from CompanionProfile: identity vs. narrative are two axes.
 * Toto with the Rainbow deployment = Rainbow's cultural voice.
 * Toto with a different deployment (e.g. a Rainbow test tenant) = same
 * companion, different story.
 *
 * Resolution:
 *   1. If Morrow is the active companion → default deployment (neutral).
 *   2. Otherwise → Rainbow deployment (the only shipping deployment today).
 *
 * When a second deployment becomes real (family, school, healthcare) the
 * resolver grows into a registry keyed by deployment id, in the same
 * shape as the companion resolver.
 */
const DeploymentContentContext = createContext(defaultDeployment);

export function DeploymentContentProvider({ children }) {
  const companion = useCompanion();
  const bundle = useMemo(() => {
    if (companion.id === "morrow") return defaultDeployment;
    return rainbowDeployment;
  }, [companion.id]);
  return (
    <DeploymentContentContext.Provider value={bundle}>
      {children}
    </DeploymentContentContext.Provider>
  );
}

export function useDeploymentContent() {
  const ctx = useContext(DeploymentContentContext);
  if (!ctx) {
    throw new Error("useDeploymentContent() called outside DeploymentContentProvider");
  }
  return ctx;
}
